import { render, staticRenderFns } from "./PlgPaymentsApi.vue?vue&type=template&id=161544c6&"
import script from "./PlgPaymentsApi.vue?vue&type=script&lang=js&"
export * from "./PlgPaymentsApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports